<img (error)="onError()" [alt]="fileAlt()" [src]="newFileSrc" />
